import { Action } from 'redux';

import { ListResultWithToken } from '~src/ts/fetchers/ListResultWithToken';

import {
  ResetContentBusyFetching,
  SpaceContentsMissingSliceRequest,
  SpaceContentsNextPageWithTokenRequest,
  SpaceContentsNextPageWithTokenSucceeded,
  SpaceContentsRequest,
  SpaceContentsRequestFailed,
  SpaceContentsRequestSucceeded,
  SpaceContentsSliceSucceeded,
  SpaceContentsUpdateOwners,
  SpaceContentsUpdateTotalCount,
  SpaceContentsWithTokenRequestSucceeded,
} from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { ListResult } from '../../ts/fetchers/ListResult';
import { IRange } from '../../ts/models/IRange';
import { IUser } from '../../ts/ServerApi/types/IUser';
import { ExplorableItemType } from '../models/ContentType';
import { IContentInfo } from '../models/IContentInfo';

export interface SpaceContentsRequestAction extends Action {}

export function requestSpaceContents(): SpaceContentsRequestAction {
  return {
    type: SpaceContentsRequest
  };
}

export const isSpaceContentsRequestAction = isActionFactory<SpaceContentsRequestAction>(SpaceContentsRequest);

//-------------------------

export interface SpaceContentsRequestSucceededAction extends Action {
  readonly content: ListResult<IContentInfo>;
}

export function spaceContentsRequestSucceeded(content: ListResult<IContentInfo>): SpaceContentsRequestSucceededAction {
  return {
    type: SpaceContentsRequestSucceeded,
    content
  };
}

export const isSpaceContentsRequestSucceededAction = isActionFactory<SpaceContentsRequestSucceededAction>(SpaceContentsRequestSucceeded);

//-------------------------

export interface SpaceContentsWithTokenRequestSucceededAction extends Action {
  readonly contentWithToken: ListResultWithToken<IContentInfo>;
}

export function spaceContentsWithTokenRequestSucceeded(contentWithToken: ListResultWithToken<IContentInfo>): SpaceContentsWithTokenRequestSucceededAction {
  return {
    type: SpaceContentsWithTokenRequestSucceeded,
    contentWithToken
  };
}

export const isSpaceContentsWithTokenRequestSucceededAction = isActionFactory<SpaceContentsWithTokenRequestSucceededAction>(SpaceContentsWithTokenRequestSucceeded);

//-------------------------

export interface SpaceContentsRequestFailedAction extends Action {}

export function spaceContentsRequestFailed(): SpaceContentsRequestFailedAction {
  return {
    type: SpaceContentsRequestFailed
  };
}

export const isSpaceContentsRequestFailedAction = isActionFactory<SpaceContentsRequestFailedAction>(SpaceContentsRequestFailed);

//-------------------------

export interface SpaceContentsMissingSliceRequestAction extends Action, IRange {}

// From start (inclusive) to end (exclusive)
export function requestSpaceContentsMissingSlice(start: number, end: number): SpaceContentsMissingSliceRequestAction {
  return {
    type: SpaceContentsMissingSliceRequest,
    start: start,
    end: end
  };
}

export const isSpaceContentsMissingSliceRequestAction = isActionFactory<SpaceContentsMissingSliceRequestAction>(SpaceContentsMissingSliceRequest);

//-------------------------

export interface SpaceContentsNextPageWithTokenRequestAction extends Action {
  nextPageToken: string;
}

export function requestSpaceContentNextPageWithToken(nextPageToken: string): SpaceContentsNextPageWithTokenRequestAction {
  return {
    type: SpaceContentsNextPageWithTokenRequest,
    nextPageToken
  };
}

export const isSpaceContentsNextPageWithTokenRequest = isActionFactory<SpaceContentsNextPageWithTokenRequestAction>(SpaceContentsNextPageWithTokenRequest);

//-------------------------

export interface SpaceContentsSliceSucceededAction extends Action {
  start: number;
  content: ListResult<IContentInfo>;
}

export function spaceContentsSliceSucceeded(start: number, content: ListResult<IContentInfo>): SpaceContentsSliceSucceededAction {
  return {
    type: SpaceContentsSliceSucceeded,
    start,
    content
  };
}

export const isSpaceContentsSliceSucceededAction = isActionFactory<SpaceContentsSliceSucceededAction>(SpaceContentsSliceSucceeded);

//-------------------------

export interface SpaceContentsNextPageWithTokenSucceededAction extends Action {
  contentWithToken: ListResultWithToken<IContentInfo>;
}

export function spaceContentNextPageWithTokenSucceeded(contentWithToken: ListResultWithToken<IContentInfo>): SpaceContentsNextPageWithTokenSucceededAction {
  return {
    type: SpaceContentsNextPageWithTokenSucceeded,
    contentWithToken
  };
}

export const isSpaceContentsNextPageWithTokenSuccededAction = isActionFactory<SpaceContentsNextPageWithTokenSucceededAction>(SpaceContentsNextPageWithTokenSucceeded);

//-------------------------

export interface UpdateOwnerData {
  contentId: string;
  ownerId: string;
  contentType: ExplorableItemType;
}

export interface SpaceContentsUpdateOwnersAction extends Action {
  owners: _.Dictionary<IUser>;
  contents: UpdateOwnerData[];
}

export function spaceContentsUpdateOwners(owners: _.Dictionary<IUser>, contents: UpdateOwnerData[]): SpaceContentsUpdateOwnersAction {
  return {
    type: SpaceContentsUpdateOwners,
    owners,
    contents
  };
}

export const isSpaceContentsUpdateOwnersAction = isActionFactory<SpaceContentsUpdateOwnersAction>(SpaceContentsUpdateOwners);

//-------------------------

export interface SpaceContentsUpdateTotalCountAction extends Action {
  totalCount: number;
}

export function spaceContentsUpdateTotalCount(totalCount: number): SpaceContentsUpdateTotalCountAction {
  return {
    type: SpaceContentsUpdateTotalCount,
    totalCount
  };
}

export const isSpaceContentsUpdateTotalCountAction = isActionFactory<SpaceContentsUpdateTotalCountAction>(SpaceContentsUpdateTotalCount);

//-------------------------

export interface ResetContentBusyFetchingAction extends Action {}

export function resetContentBusyFetching(): ResetContentBusyFetchingAction {
  return {
    type: ResetContentBusyFetching
  };
}

export const isResetContentBusyFetchingAction = isActionFactory<ResetContentBusyFetchingAction>(ResetContentBusyFetching);
